import {useContext} from 'react'

import {OrderConfirmationContext} from '../context/OrderConfirmationContext'

/**
 * Custom hook to access OrderConfirmationContext.
 * Provides quantity range configuration for order confirmation flow.
 *
 * @returns OrderConfirmationContext value with quantityRange configuration
 * @throws Error if used outside of OrderConfirmationContext.Provider
 */
export const useOrderConfirmationContext = () => {
  const context = useContext(OrderConfirmationContext)

  if (!context) {
    throw new Error(
      'useOrderConfirmationContext must be used within OrderConfirmationContext.Provider'
    )
  }

  return context
}
